export default __webpack_public_path__ + "img/d6ffbfc23dd5d60ed749a7c31cd47a59.png";